export default __webpack_public_path__ + "static/media/TopoAnimation_rev.77824ff4.gif";